import { CONTACT_US_MODAL_SHOW } from '../constants';

const defaultState = {
  title: '',
  description: '',
  contactInformationItems: [],
  buttonText: '',
  buttonLink: '',
  showContactUs: false,
  open: false,
};

export const contactUs = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case CONTACT_US_MODAL_SHOW:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
